import { useGuestAccessStore } from '../stores/useGuestAccessStore';
import { GuestData } from '../types';

export const useGuestAccess = () => {
  const [data, setGuestData] = useGuestAccessStore((store) => [
    store.data,
    store.setGuestData,
  ]);

  const persistGuestState = (guestData: GuestData) => {
    setGuestData(guestData);
  };

  const clearGuestState = () => {
    setGuestData(null);
  };

  return {
    data,
    persistGuestState,
    clearGuestState,
  };
};
